export const CLINICIAN_SEARCH_WEEKDAY_ORDER = [1, 2, 3, 4, 5, 6, 0];

const FACET_LOCALE_PREFIX = 'booking.clinicianSearch.facets';
const WEEKDAY_LOCALE_PREFIX = `${FACET_LOCALE_PREFIX}.weekdays`;
const TIME_BUCKET_LOCALE_PREFIX = `${FACET_LOCALE_PREFIX}.timeBuckets`;

export const CLINICIAN_SEARCH_WEEKDAY_LABEL_KEYS = [
  `${WEEKDAY_LOCALE_PREFIX}.sunday`,
  `${WEEKDAY_LOCALE_PREFIX}.monday`,
  `${WEEKDAY_LOCALE_PREFIX}.tuesday`,
  `${WEEKDAY_LOCALE_PREFIX}.wednesday`,
  `${WEEKDAY_LOCALE_PREFIX}.thursday`,
  `${WEEKDAY_LOCALE_PREFIX}.friday`,
  `${WEEKDAY_LOCALE_PREFIX}.saturday`,
];

export const CLINICIAN_SEARCH_TIME_BUCKET_ORDER = [0, 1, 2, 3];

export const CLINICIAN_SEARCH_TIME_BUCKET_LABEL_KEYS = [
  `${TIME_BUCKET_LOCALE_PREFIX}.earlyMorning`,
  `${TIME_BUCKET_LOCALE_PREFIX}.morning`,
  `${TIME_BUCKET_LOCALE_PREFIX}.afternoon`,
  `${TIME_BUCKET_LOCALE_PREFIX}.evening`,
];

export function clinicianSearchWeekdayLabelKey(weekdayId) {
  return CLINICIAN_SEARCH_WEEKDAY_LABEL_KEYS[weekdayId] ?? null;
}

export function clinicianSearchTimeBucketLabelKey(timeBucketId) {
  return CLINICIAN_SEARCH_TIME_BUCKET_LABEL_KEYS[timeBucketId] ?? null;
}

function toNumericDocCount(docCount) {
  if (typeof docCount === 'number' && !Number.isNaN(docCount)) {
    return docCount;
  }
  let n = Number(docCount);
  return Number.isNaN(n) ? 0 : n;
}

export function facetOptionDisabled(docCount, isCurrentlyActive) {
  let n = toNumericDocCount(docCount);
  return n <= 0 && !isCurrentlyActive;
}

export function sortOfficesByPlacement(offices) {
  let fields = ['isVideo', 'notPublic', 'distance'];
  return [...offices].sort((a, b) => {
    for (let field of fields) {
      let av = a[field];
      let bv = b[field];
      if (av === bv) {
        continue;
      }
      if (av === undefined || av === null) {
        return 1;
      }
      if (bv === undefined || bv === null) {
        return -1;
      }
      return av < bv ? -1 : 1;
    }
    return 0;
  });
}
